<template>
  <rand-money :title="title" :cur-class="curClass" />
</template>

<script>
import RandMoney from '@/views/config/rand-conf/rand-money.vue'

export default {
  name: 'RandCooperativeCoin',
  components: { RandMoney },
  data() {
    return {
      title: '随机代币配置',
      curClass: 'randCooperativeCoin'
    }
  }
}
</script>

